require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-business-process.json") })
        }
      }, "path---tutorials-examples-business-process");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-business-process!./.cache/json/tutorials-examples-business-process.json
// module id = 770
// module chunks = 231608221292675